import { render, staticRenderFns } from "./UDBack.vue?vue&type=template&id=7285194f"
import script from "./UDBack.vue?vue&type=script&lang=js"
export * from "./UDBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports